// extracted by mini-css-extract-plugin
export var linkhover = "index-module--linkhover--3iDku";
export var Hours = "index-module--Hours--jjOim";
export var status = "index-module--status--kmK1r";
export var change = "index-module--change--Xx8qa";